import { PlusOutlined } from "@ant-design/icons";
import { Button, message, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";
import StationModal from "./components/StationModal";

function Stations() {
  const [editingKey, setEditingKey] = useState(null);
  const [stations, setStations] = useState({});
  const [campuses, setCampuses] = useState([]);
  const [showStationModal, setShowStationModal] = useState(false);

  useEffect(() => {
    fetchStations();
    fetchCampuses();
  }, []);

  const fetchCampuses = async () => {
    const res = await apiRequest({
      path: apiPaths.campuses,
    });
    if (!res.error) {
      setCampuses(res.results);
    }
  };

  const fetchStations = async () => {
    const res = await apiRequest({
      path: apiPaths.stations,
    });
    if (!res.error) {
      let itemsObj = res.results.reduce((items, item) => {
        items[item.id + "d"] = item;
        return items;
      }, {});
      setStations(itemsObj);
    } else {
      message.error(res.error_description);
    }
  };

  const COLUMNS = [
    {
      title: "Name",
      dataIndex: "name",
      width: "220px",
      filterType: "search",
      fixed: "left",
    },
    {
      title: "Code",
      dataIndex: "code",
      width: "150px",
      filterType: "search",
    },
    {
      title: "Campus",
      dataIndex: "campus.name",
      filterType: "search",
      width: "220px",
    },
    {
      title: "Type",
      dataIndex: "station_type",
      filterType: "search",
      width: "220px",
    },
    {
      title: "Lat,Long",
      dataIndex: "latitude",
      width: "220px",
      render: (_, record) =>
        record.latitude ? record.latitude + "," + record.longitude : "",
    },
    {
      title: "Created Date",
      dataIndex: "date_create",
      width: "150px",
      filterType: "date",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },

    {
      title: "Updated Date",
      dataIndex: "date_modify",
      filterType: "date",
      width: "150px",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },
  ];

  const handleRowCanceled = () => {
    setShowStationModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowStationModal(true);
  };

  const handleRowSave = async (row) => {
    if (editingKey == null) {
      const res = await apiRequest({
        path: apiPaths.stations,
        method: "POST",
        data: row,
      });
      if (res.error) {
        message.error(res.error_description);
        return;
      }
      setStations({ [res.id + "d"]: res, ...stations });
      setShowStationModal(false);
      return;
    }
    let key = editingKey;
    const res = await apiRequest({
      path: apiPaths.stations + `/${key}`,
      method: "PUT",
      data: row,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    stations[editingKey + "d"] = res;
    setStations({ ...stations });
    setEditingKey(null);
    setShowStationModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: 10,
        }}
      >
        <Tooltip title="Add Station">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingKey(null);
              setShowStationModal(true);
            }}
          />
        </Tooltip>
      </div>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(stations)}
          columns={COLUMNS}
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          editHandler={(record) => handleRowEdit(record.id)}
          pagination={false}
        />
      </div>
      {showStationModal ? (
        <StationModal
          open={showStationModal}
          onSave={handleRowSave}
          onCancel={handleRowCanceled}
          data={stations[editingKey + "d"]}
          isUpdate={editingKey != null}
          campuses={campuses}
        />
      ) : null}
    </div>
  );
}

export default Stations;
